import React, { Component, PropTypes } from 'react';
import ContractorSplash from './contractor-profile-completeness-splash';
import SupplierSplash from './supplier-profile-completeness-splash';


class ProfileCompleteSplash extends Component {
  render() {
    return (
      this.props.user.user.type === 'Supplier' ?
      <SupplierSplash {...this.props} /> :
      <ContractorSplash {...this.props} />
    );
  }
}

ProfileCompleteSplash.propTypes = {
  user: PropTypes.object,
};

export default ProfileCompleteSplash;



// WEBPACK FOOTER //
// ./src/app/components/splash-pages/profile-complete-splash.jsx